export default {fields:{containerSchemaId:{},height:{},width:{}},spreads:{BaseStorableSchema:{}}}